// SPDX-License-Identifier: GPL-3.0-or-later
// Code-built spinner. The upstream spinner loads JSON meshes. This one is a thin plate and
// two posts. The plate turns about the x axis of the item, at `height` above the playfield.

import { BoxGeometry, type BufferGeometry, CylinderGeometry } from "three";
import type { SpinnerSpec } from "../../shared/contracts.ts";

/** The parts of a spinner. */
export interface SpinnerGeometry {
  /** One post. The scene puts one at each end of the plate. */
  readonly post: BufferGeometry;
  /** The plate. Its origin is the pivot line, in the middle of the plate. */
  readonly plate: BufferGeometry;
  /** Height of the pivot above the playfield. */
  readonly pivotHeight: number;
}

/** Build the geometry of a spinner. */
export function generateSpinner(spec: SpinnerSpec): SpinnerGeometry {
  const pivotHeight = Math.max(spec.height, 6);
  const plateHeight = Math.max(spec.height * 1.2, 12);
  const post = new CylinderGeometry(1.8, 1.8, pivotHeight + 2, 10);
  post.translate(0, (pivotHeight + 2) / 2, 0);
  post.name = `spinner.post-${spec.name}`;
  const plate = new BoxGeometry(spec.length, plateHeight, 1.6);
  plate.name = `spinner.plate-${spec.name}`;
  return { post, plate, pivotHeight };
}
